import { CategoryModel } from "./CategoryModel";
import * as moment from 'moment';

export class ChapterArticle {
    Author: string;
    Category: CategoryModel;
    CategoryId: string;
    Chapter: string;
    Date: Date;
    EventDate?: Date;
    StartDate: string;
    EndDate: string;
    EventDateAsString: string;
    DateAsString: string;
    DateLabel: string;
    Thumbnail: string;
    ThumbnailAlt: string;
    Media: string;
    Summary: string;
    Title: string;
    NodeId: number;
    Url: string;
    ExternalLink: string;
    ExternalLinkOpenNewWindow: boolean;
    IsEventLive: boolean;
}

export class CalendarChapterArticle extends ChapterArticle {
    start: Date;
    end: Date;
    allDay: boolean;

    constructor() {
        super();
    }

    public static fromChapterArticle(input: ChapterArticle): CalendarChapterArticle {

        const result = { ...new CalendarChapterArticle(), ...input };

        console.log('CalendarChapterArticle', result);

        result.start = moment(result.StartDate).toDate();
        result.end = moment(result.EndDate).toDate();
        result.allDay = result.StartDate == result.EndDate;

        return result;
    }
}